import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import Styles from './DealEditorBody.module.scss';
import type { DealParam } from '~/models/DealForm';
import { DealTypeBlock } from './block/DealTypeBlock';
import { MoveOutBlock } from './block/MoveOutBlock';
import { OtherBlock } from './block/OtherBlock';
import { RepairBlock } from './block/RepairBlock';
import { RoomBlock } from './block/RoomBlock';
import { TenantBlock } from './block/TenantBlock';
import { useKtLeasings } from '~/hooks/useKtLeasings';
import type { PropertyRoomOption } from '~/models/PropertyRoomOption';
import { buildPropertyRoomOptionsFromLeasing } from '~/models/PropertyRoomOption';
import { useDealQueryParams } from '~/pages/deals/new';

export const DealEditorBodyV2: React.FC = () => {
  const { leasingId } = useDealQueryParams();
  const { watch } = useFormContext<DealParam>();
  const dealType = watch('dealType');
  const [selectedRoom, setSelectedRoom] =
    React.useState<PropertyRoomOption | null>(null);
  const { data: leasing } = useKtLeasings().leasingInfo(leasingId);

  useEffect(() => {
    if (!leasing) return;
    setSelectedRoom(buildPropertyRoomOptionsFromLeasing(leasing));
  }, [leasing]);

  return (
    <div className={Styles.DealEditorBody}>
      <DealTypeBlock />
      <RoomBlock
        leasing={leasing}
        selectedRoom={selectedRoom}
        setSelectedRoom={setSelectedRoom}
      />
      {dealType === 'repair' && <RepairBlock />}
      <TenantBlock currentRoom={selectedRoom} leasing={leasing} />
      <MoveOutBlock dealType={dealType} leasing={leasing} />
      <OtherBlock />
    </div>
  );
};
